import { createModel, RematchDispatch } from '@rematch/core';
import { message } from 'antd';
import produce from 'immer';
import { FILE_NAME_TYPE } from '../../commons/constants/constants';
import { uploadFiles } from '../../services/uploader.service';
import {
  createUserContact,
  deleteUserContact,
  getUserContacts,
  updateUserContact,
} from '../../services/userContact.service';
import { RootModel } from '../models';

export const storeName = 'userContacts';
export const DEFAULT_USER_CONTACT_PAGE_SIZE = 5;

const initialState = {
  data: [],
  loading: false,
  edit: {
    visible: false,
    item: null,
  },
};

export const userContacts: any = createModel<RootModel>()({
  name: storeName,
  state: initialState,
  reducers: {
    setLoading: produce((state, payload) => {
      state.loading = payload;
    }),
    setData: produce((state, payload) => {
      state.data = payload;
    }),
    setEditItem: produce((state, payload) => {
      state.edit = {
        visible: !!payload,
        item: payload,
      };
    }),
  },
  effects: (dispatch: RematchDispatch<typeof userContacts>) => ({
    async saveUserContact(payload, state) {
      dispatch.tourGuides.setLoading(true);
      let result;
      try {
        const editing = !!payload.id;
        const { user } = state;
        const { avatar, companyAvatar, ...params } = payload;
        if (avatar) {
          const uploadResult = await uploadFiles(
            null,
            avatar,
            FILE_NAME_TYPE.IMAGE,
            user.id,
            'usercontacts'
          );

          const { filesList = [] } = uploadResult;
          if (filesList[0]) {
            params.avatar = {
              id: filesList[0].id,
              name: filesList[0].name,
              url: filesList[0].url,
            };
          }
        }

        if (companyAvatar) {
          const uploadResult = await uploadFiles(
            null,
            companyAvatar,
            FILE_NAME_TYPE.IMAGE,
            user.id,
            'usercontacts'
          );

          const { filesList = [] } = uploadResult;
          if (filesList[0]) {
            params.companyAvatar = {
              id: filesList[0].id,
              name: filesList[0].name,
              url: filesList[0].url,
            };
          }
        }
        if (!editing) {
          result = await createUserContact(params);
        } else {
          result = await updateUserContact(payload.id, params);
        }
        message.success('Save User Contact Successfully');
        dispatch.userContacts.setEditItem(null);
        dispatch.userContacts.loadUserContacts();
        return result;
      } catch (err) {
        message.error(`Save User Contact Failed: ${err.message}`);
        console.error(err.message);
        return err;
      }
    },
    async loadUserContacts(payload) {
      const params = {
        page: payload ? payload.page - 1 : 0,
        size: payload ? payload.size : DEFAULT_USER_CONTACT_PAGE_SIZE,
      };
      dispatch.userContacts.setLoading(true);
      const res = await getUserContacts({ params });
      if (res && res.data) {
        dispatch.userContacts.setData(res.data);
      }

      dispatch.userContacts.setLoading(false);
    },
    async deleteUserContact(payload) {
      try {
        await deleteUserContact(payload);
        dispatch.userContacts.loadUserContacts();
        message.success('Success to delete user contact!');
      } catch (e) {
        console.error(e);
        message.error('Fail to delete! User Contact could be used in tour!');
      }
    },
  }),
});

export default userContacts;
